import { Dispatch, SetStateAction, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, LinearProgress } from "@mui/material";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function CustomerHealthScore({
    open,
    onClose,
    setOpen,
}: ModalProps) {

    const healthScores = [
        {
            label: "Recency (Last Order)",
            value: 85,
            trend: "up",
            trendValue: "85",
            description: "Last ordered 2 days ago",
            color: "green",
        },
        {
            label: "Order Frequency",
            value: 45,
            trend: "down",
            trendValue: "45",
            description: "Orders decreased by 20% this month",
            color: "orange",
        },
        {
            label: "Monetary Value (LTV)",
            value: 92,
            trend: "up",
            trendValue: "92",
            description: "High lifetime value customer ($4,200+)",
            color: "green",
        },
        {
            label: "Refund Rate",
            value: 30,
            trend: "down",
            trendValue: "30",
            description: "Refunds on 12% of total orders",
            color: "orange",
        },
        {
            label: "Support Tickets",
            value: 65,
            trend: "up",
            trendValue: "65",
            description: "2 active support inquiries",
            color: "purple",
        },
    ];

    return (
        <Modal className="modal health_score_modal" open={open} onClose={onClose}>
            <div className="modal-dialog">
                <div className="modal-body">

                    {/* Header */}
                    <div className="modal_title">
                        <div className="lt">
                            <h2>Arpit Sharma</h2>
                            <p>CUST-8842 · Premium Tier</p>
                        </div>
                        <button className="btn-close" onClick={() => setOpen(false)}>
                            <CloseIcon />
                        </button>
                    </div>

                    <div className="health_summary">
                        <h4>Customer Health Score<span className="score">78.5 <i className="arrow">▲</i></span><span className="score_change">4.2 in 30 days</span></h4>
                        <p>Overall health is strong, though order frequency has dipped recently. High LTV indicates significant retention potential.</p>
                    </div>

                    {/* Content */}
                    <div className="health_score_view">
                        {healthScores.map((item, index) => (
                            <div className="score_row" key={index}>
                                <div className="score_header">
                                    <label>{item.label}</label>

                                    <div className="score_meta">
                                        <span>{item.value}%</span>
                                        <span className={`trend ${item.trend}`}>
                                            {item.trendValue} <i className="arrow">{item.trend === "up" ? "▲" : "▼"}</i>
                                        </span>
                                    </div>
                                </div>

                                <div className="progress_flex">
                                    <p className="score_desc">{item.description}</p>
                                    <LinearProgress
                                        variant="determinate"
                                        value={item.value}
                                        className={`score_bar ${item.color}`}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="recommended_actions">
                        <h4>Strategic Enablement</h4>

                        <ul>
                            <li>
                                <EmailOutlinedIcon />
                                <strong>Retention Action:</strong> Send personalized re-engagement discount
                            </li>
                            <li>
                                <FlagOutlinedIcon />
                                <strong>VIP Handling:</strong> Assign dedicated account concierge
                            </li>
                            <li>
                                <BlockOutlinedIcon />
                                <strong>Campaign Targeting:</strong> Add to "High-Value Reactivation" segment
                            </li>
                        </ul>
                    </div>

                    {/* Footer */}
                    <div className="footer_btn_flex right">
                        <Button className="btn btn_grey" onClick={() => setOpen(false)}>
                            Close
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
